import {
    AppBar,
    BottomNavigation,
    BottomNavigationAction,
    Box,
    IconButton,
    makeStyles,
    Tab,
    Tabs,
    Toolbar,
    Typography,
} from '@material-ui/core';
import { useEffect, useReducer, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { SIcon } from '../Icon';
import MainTab from '../MainTab';
import { COLORS } from '../Theme';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    appBar: {
        top: 0,
        height: '12vh',
        // minHeight: '104px',
        bottom: 'auto',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        boxShadow: 'none',
    },
    appBar2: {
        top: 0,
        paddingTop: '1vh',
        height: '7vh',
        // minHeight: '104px',
        bottom: 'auto',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        boxShadow: 'none',
    },
    logoBar: {
        height: '62%',
        minHeight: '32px',
    },
    logo: {
        margin: 'auto',
        '& img': {
            width: '45vw',
        },
    },
    IconSize: {
        width: '6vw',
        height: '6vw',
    },

    tabBar: {
        height: '38%',
        minHeight: '30px',

        '& > div > div': {
            height: '100%',
        },
        '& > div > div > a': {
            height: '100%',
            minHeight: '30px',
            minWidth: '20vw',
        },
        '& .Mui-selected': {
            color: `${COLORS.WHITE}`,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
        '& .MuiTabs-indicator': {
            backgroundColor: `${COLORS.PUMPKIN}`,
        },
    },
    linkTab: {
        fontSize: '3vw',
        fontFamily: 'NanumR',
        padding: 0,
        '&:hover': {
            color: `${COLORS.WHITE}`,
        },
    },

    topNav: {
        width: '100vw',
        height: '10vh',
        top: 0,
        bottom: 'auto',

        borderRadius: '36px 36px 0 0',
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        // border: `solid 0.5px ${COLORS.VERY_LIGHT_PINK}`,
        // backgroundColor: `${COLORS.WHITE}`,
    },
    navigationBtn: {
        width: '20%',
        minWidth: 50,
    },
}));

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && (
                // {children}
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: any) {
    return {
        id: `nav-tab-${index}`,
        'aria-controls': `nav-tabpanel-${index}`,
    };
}

interface LinkTabProps {
    label?: string;
    href?: string;
    history?: any;
    classNameProps?: any;
    member?: any;
}

function LinkTab(props: LinkTabProps) {
    return (
        <Tab
            component="a"
            onClick={(
                event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
            ) => {
                event.preventDefault();
                //props.history.push(props.href);

                props.history.push({
                    pathname: props.href,
                    ...(props.member && {
                        state: {
                            // location state
                            code: props.member.classCode,
                        },
                    }),
                });
            }}
            className={props.classNameProps}
            {...props}
        />
    );
}

// 경영현황 / 연구개발 / 재료구매 / 제품생산 / 제품판매
const address = [
    '/CompanyInfo',
    '/LicenseList',
    '/ProductionList',
    '/MaterialPurchase',
    '/ProductList' /*'/ProductSale'*/,
];
const HeaderBar: React.FC<any> = (props) => {
    const classes = useStyles();

    const [value, setValue] = useState(setInitValue(window.location.pathname));
    const history = useHistory();

    const goSetting = () => {
        history.push(`/setting`);
    };

    const goQnA = () => {
        history.push(`/qna`);
    };

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        console.log(newValue);
        setValue(newValue);
    };

    function setInitValue(path: string) {
        if (path == '/') return 0;

        return address.findIndex((element) => element == path) || 0;
    }

    const convertPath = (pathName: string) => {
        if (pathName == '/') return 0;
        return address.findIndex((element) => element == pathName);
    };

    const refresh = () => {
        window.location.reload();
    };

    useEffect(() => {
        console.log('history?', history);

        if (history !== undefined) {
            return history.listen((location: any, action: any) => {
                if (action === 'POP') {
                    console.log('just POP!');
                    setValue(convertPath(location.pathname));
                }
            });
        } else {
            return;
        }
    }, [history]);

    useEffect(() => {
        console.log('change value', value);
    }, [value]);

    return (
        <>
            <AppBar position="static" className={classes.appBar} translate="no">
                <Toolbar className={classes.logoBar}>
                    <Box display="flex" style={{ width: '100%' }}>
                        <Box flexGrow={1} className={classes.logo}>
                            <img src="/images/logo_white.png" />
                        </Box>
                        <Box>
                            <IconButton onClick={goQnA} style={{ padding: 0 }}>
                                <img
                                    className={classes.IconSize}
                                    src="/images/question.png"
                                />
                            </IconButton>
                            <IconButton
                                onClick={goSetting}
                                style={{ padding: 0, paddingLeft: '3vw' }}
                            >
                                <img
                                    className={classes.IconSize}
                                    src="/images/Settings.webp"
                                />
                            </IconButton>
                            <IconButton
                                onClick={refresh}
                                style={{ padding: 0, paddingLeft: '3vw' }}
                            >
                                <img
                                    className={classes.IconSize}
                                    src="/images/refresh_white2.png"
                                />
                            </IconButton>
                        </Box>
                    </Box>
                </Toolbar>
                <Tabs
                    className={classes.tabBar}
                    variant="fullWidth"
                    value={value}
                    onChange={handleChange}
                    aria-label="nav tabs"
                >
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="경영현황"
                        href={address[0]}
                        history={history}
                        {...a11yProps(0)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="연구개발"
                        href={address[1]}
                        history={history}
                        {...a11yProps(1)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="제품생산"
                        href={address[2]}
                        history={history}
                        {...a11yProps(2)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="재료구매"
                        href={address[3]}
                        history={history}
                        {...a11yProps(3)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="제품판매"
                        href={address[4]}
                        history={history}
                        {...a11yProps(4)}
                    />
                </Tabs>
            </AppBar>
        </>
    );
};

const oper_address = [
    '/operation/company/list',
    '/operation/decomposition/appList',
    '/operation/ClassRun',
];
export const OperHeaderBar: React.FC<any> = (props) => {
    const classes = useStyles();

    const [value, setValue] = useState(setInitValue(window.location.pathname));
    const { oper } = props;
    const history = useHistory();
    const [_, forceUpdate] = useReducer((x: any) => x + 1, 0);

    const goSetting = () => {
        history.push(`/setting`);
    };

    const goQnA = () => {
        history.push(`/qna`);
    };

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        console.log(newValue);
        setValue(newValue);
    };

    function setInitValue(path: string) {
        if (path == '/') return 0;
        return oper_address.find((element) => element == path) || 0;
    }
    const refresh = () => {
        // window.location.reload()
        history.go(0);
        console.log('click refresh');
        // forceUpdate()
    };

    return (
        <>
            <AppBar position="static" className={classes.appBar} translate="no">
                <Toolbar className={classes.logoBar}>
                    <Box display="flex" style={{ width: '100%' }}>
                        <Box flexGrow={1} className={classes.logo}>
                            <img src="/images/logo_white.png" />
                        </Box>
                        <Box>
                            <IconButton onClick={goQnA} style={{ padding: 0 }}>
                                <img
                                    className={classes.IconSize}
                                    src="/images/question.png"
                                />
                            </IconButton>
                            <IconButton
                                onClick={goSetting}
                                style={{ padding: 0, paddingLeft: '3vw' }}
                            >
                                <img
                                    className={classes.IconSize}
                                    src="/images/Settings.webp"
                                />
                            </IconButton>
                            <IconButton
                                onClick={refresh}
                                style={{ padding: 0, paddingLeft: '3vw' }}
                            >
                                <img
                                    className={classes.IconSize}
                                    src="/images/refresh_white2.png"
                                />
                            </IconButton>
                        </Box>
                    </Box>
                </Toolbar>
                <Tabs
                    className={classes.tabBar}
                    variant="fullWidth"
                    value={value}
                    onChange={handleChange}
                    aria-label="nav tabs"
                >
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="기업리스트"
                        href={oper_address[0]}
                        history={history}
                        {...a11yProps(0)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="분해완료처리"
                        href={oper_address[1]}
                        history={history}
                        {...a11yProps(1)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="랭킹페이지"
                        href={oper_address[2]}
                        history={history}
                        {...a11yProps(2)}
                        member={oper}
                    />
                </Tabs>
            </AppBar>
        </>
    );
};

// 경영현황 / 재료판매(승인) / 재료목록 / 재료구매
const d_address = [
    '/CompanyInfo',
    '/MaterialSale',
    '/ProductPurchase',
    '/MaterialList',
    '/ProductList',
];
export const DistributionHeaderBar: React.FC<any> = (props) => {
    const classes = useStyles();

    const [value, setValue] = useState(setInitValue(window.location.pathname));
    const history = useHistory();

    const goSetting = () => {
        history.push(`/setting`);
    };

    const goQnA = () => {
        history.push(`/qna`);
    };

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        console.log(newValue);
        setValue(newValue);
    };

    function setInitValue(path: string) {
        if (path == '/') return 0;

        return address.findIndex((element) => element == path) || 0;
    }

    const convertPath = (pathName: string) => {
        if (pathName == '/') return 0;
        return address.findIndex((element) => element == pathName);
    };

    const refresh = () => {
        window.location.reload();
    };

    useEffect(() => {
        console.log('history?', history);

        if (history !== undefined) {
            return history.listen((location: any, action: any) => {
                if (action === 'POP') {
                    console.log('just POP!');
                    setValue(convertPath(location.pathname));
                }
            });
        } else {
            return;
        }
    }, [history]);

    useEffect(() => {
        console.log('change value', value);
    }, [value]);

    return (
        <>
            <AppBar position="static" className={classes.appBar} translate="no">
                <Toolbar className={classes.logoBar}>
                    <Box display="flex" style={{ width: '100%' }}>
                        <Box flexGrow={1} className={classes.logo}>
                            <img src="/images/logo_white.png" />
                        </Box>
                        <Box>
                            <IconButton onClick={goQnA} style={{ padding: 0 }}>
                                <img
                                    className={classes.IconSize}
                                    src="/images/question.png"
                                />
                            </IconButton>
                            <IconButton
                                onClick={goSetting}
                                style={{ padding: 0, paddingLeft: '3vw' }}
                            >
                                <img
                                    className={classes.IconSize}
                                    src="/images/Settings.webp"
                                />
                            </IconButton>
                            <IconButton
                                onClick={refresh}
                                style={{ padding: 0, paddingLeft: '3vw' }}
                            >
                                <img
                                    className={classes.IconSize}
                                    src="/images/refresh_white2.png"
                                />
                            </IconButton>
                        </Box>
                    </Box>
                </Toolbar>
                <Tabs
                    className={classes.tabBar}
                    variant="fullWidth"
                    value={value}
                    onChange={handleChange}
                    aria-label="nav tabs"
                >
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="경영현황"
                        href={d_address[0]}
                        history={history}
                        {...a11yProps(0)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="재료판매"
                        href={d_address[1]}
                        history={history}
                        {...a11yProps(1)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="제품구매"
                        href={d_address[2]}
                        history={history}
                        {...a11yProps(2)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="보유재료"
                        href={d_address[3]}
                        history={history}
                        {...a11yProps(2)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="보유제품"
                        href={d_address[4]}
                        history={history}
                        {...a11yProps(3)}
                    />
                </Tabs>
            </AppBar>
        </>
    );
};

// 경영현황 / 제품구매(승인) / 제품목록 / 재료목록 / 재료판매(승인)
const s_address = [
    '/CompanyInfo',
    '/ProductPurchase',
    '/ProductList',
    '/MaterialList',
    '/MaterialSale',
];
export const ServiceHeaderBar: React.FC<any> = (props) => {
    const classes = useStyles();

    const [value, setValue] = useState(setInitValue(window.location.pathname));
    const history = useHistory();

    const goSetting = () => {
        history.push(`/setting`);
    };

    const goQnA = () => {
        history.push(`/qna`);
    };

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        console.log(newValue);
        setValue(newValue);
    };

    function setInitValue(path: string) {
        if (path == '/') return 0;

        return address.findIndex((element) => element == path) || 0;
    }

    const convertPath = (pathName: string) => {
        if (pathName == '/') return 0;
        return address.findIndex((element) => element == pathName);
    };

    const refresh = () => {
        window.location.reload();
    };

    useEffect(() => {
        console.log('history?', history);

        if (history !== undefined) {
            return history.listen((location: any, action: any) => {
                if (action === 'POP') {
                    console.log('just POP!');
                    setValue(convertPath(location.pathname));
                }
            });
        } else {
            return;
        }
    }, [history]);

    useEffect(() => {
        console.log('change value', value);
    }, [value]);

    return (
        <>
            <AppBar position="static" className={classes.appBar} translate="no">
                <Toolbar className={classes.logoBar}>
                    <Box display="flex" style={{ width: '100%' }}>
                        <Box flexGrow={1} className={classes.logo}>
                            <img src="/images/logo_white.png" />
                        </Box>
                        <Box>
                            <IconButton onClick={goQnA} style={{ padding: 0 }}>
                                <img
                                    className={classes.IconSize}
                                    src="/images/question.png"
                                />
                            </IconButton>
                            <IconButton
                                onClick={goSetting}
                                style={{ padding: 0, paddingLeft: '3vw' }}
                            >
                                <img
                                    className={classes.IconSize}
                                    src="/images/Settings.webp"
                                />
                            </IconButton>
                            <IconButton
                                onClick={refresh}
                                style={{ padding: 0, paddingLeft: '3vw' }}
                            >
                                <img
                                    className={classes.IconSize}
                                    src="/images/refresh_white2.png"
                                />
                            </IconButton>
                        </Box>
                    </Box>
                </Toolbar>
                <Tabs
                    className={classes.tabBar}
                    variant="fullWidth"
                    value={value}
                    onChange={handleChange}
                    aria-label="nav tabs"
                >
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="경영현황"
                        href={s_address[0]}
                        history={history}
                        {...a11yProps(0)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="제품구매"
                        href={s_address[1]}
                        history={history}
                        {...a11yProps(1)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="제품목록"
                        href={s_address[2]}
                        history={history}
                        {...a11yProps(2)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="재료목록"
                        href={s_address[3]}
                        history={history}
                        {...a11yProps(3)}
                    />
                    <LinkTab
                        classNameProps={classes.linkTab}
                        label="재료판매"
                        href={s_address[4]}
                        history={history}
                        {...a11yProps(4)}
                    />
                </Tabs>
            </AppBar>
        </>
    );
};

export const OperatorHeaderBar: React.FC<any> = (props) => {
    const classes = useStyles();

    const [value, setValue] = useState(setInitValue(window.location.pathname));
    const history = useHistory();
    const [_, forceUpdate] = useReducer((x: any) => x + 1, 0);

    const goSetting = () => {
        history.push(`/setting`);
    };

    const goQnA = () => {
        history.push(`/qna`);
    };

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        console.log(newValue);
        setValue(newValue);
    };

    function setInitValue(path: string) {
        if (path == '/') return 0;
        return oper_address.find((element) => element == path) || 0;
    }
    const refresh = () => {
        history.go(0);
        console.log('click refresh');
    };

    return (
        <>
            <AppBar
                position="static"
                className={classes.appBar2}
                translate="no"
            >
                <Toolbar className={classes.logoBar}>
                    <Box display="flex" style={{ width: '100%' }}>
                        <Box flexGrow={1} className={classes.logo}>
                            <img src="/images/logo_white.png" />
                        </Box>
                        <Box>
                            <IconButton onClick={goQnA} style={{ padding: 0 }}>
                                <img
                                    className={classes.IconSize}
                                    src="/images/question.png"
                                />
                            </IconButton>
                            <IconButton
                                onClick={goSetting}
                                style={{ padding: 0, paddingLeft: '3vw' }}
                            >
                                <img
                                    className={classes.IconSize}
                                    src="/images/Settings.webp"
                                />
                            </IconButton>
                            <IconButton
                                onClick={refresh}
                                style={{ padding: 0, paddingLeft: '3vw' }}
                            >
                                <img
                                    className={classes.IconSize}
                                    src="/images/refresh_white2.png"
                                />
                            </IconButton>
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>
        </>
    );
};

export const TopNavigation = () => {
    const classes = useStyles();
    const [value, setValue] = useState(setInitValue(window.location.pathname));

    const handleChange = (event: any, newValue: any) => {
        setValue(newValue);
    };

    // change to useMemo?
    function setInitValue(path: string) {
        if (path == '/' || path == '/test') {
            return 0;
        } else if (path == '/login') {
            return 1;
        } else if (path == '/operation/') {
            return 2;
        } else if (path == '/operation/product/purchase/list') {
            return 3;
        } else {
            return 0;
        }
    }

    return (
        <BottomNavigation
            value={value}
            onChange={handleChange}
            showLabels
            className={classes.topNav}
            translate="no"
        >
            <BottomNavigationAction
                className={classes.navigationBtn}
                selected={true}
                component={Link}
                to="/test"
                value={0}
                label="재료주문"
            />
            <BottomNavigationAction
                className={classes.navigationBtn}
                component={Link}
                to="/login"
                value={1}
                label="재료완료"
            />
            <BottomNavigationAction
                className={classes.navigationBtn}
                component={Link}
                to="/operation"
                value={2}
                label="상품주문"
            />
        </BottomNavigation>
    );
};

export default HeaderBar;
